export const branding = {
    palette: {
        primary: {
            main: '#42424E',
        },
        secondary: {
            main: '#C03256',
        },
        navigation: {
            main: '#C03256',
        },
        header: {
            main: '#42424E',
            contrastText: '#222',
        },
    },
    logoUrl:
        'https://adviserplus.com/wp-content/uploads/2019/03/logo-ap-fixed.svg',
}
